export enum IframeIDEnum {
  'game' = 'game',
}

export enum IframeEventTypeEnum {
  'ON_LOADED' = 'onLoaded',
  'ON_CONNECT_WALLET' = 'connectWallet',
  'ON_DISCONNECT_WALLET' = 'disconnectWallet',
  'GET_WALLET_INFO' = 'getWalletInfo',
  'PAY' = 'pay',
  'USE_COIN' = 'useCoin',
  'UPDATE_LEVEL' = 'updateLevel',
  'GET_USER_TOKEN' = 'getUserToken',
  'GET_USER_INFO' = 'getUserInfo',
  'GET_LEADER_BOARD' = 'getLeaderBoard',
  'GET_LEADER_BOARD_ALL' = 'getLeaderBoardAll',
  'ON_SHARE' = 'share',
  'ON_GET_ITEM_CONFIG' = 'getItemConfig',
}

export enum IframeEventEnum {
  'ON_LOADED' = 'OnLoaded',
  'ON_CONNECT_WALLET' = 'OnConnectWallet',
  'ON_DISCONNECT_WALLET' = 'OnDisconnectWallet',
  'ON_GET_WALLET_INFO' = 'OnGetWalletInfo',
  'ON_PAY' = 'OnPay',
  'ON_USE_COIN' = 'OnUseCoin',
  'ON_UPDATE_LEVEL' = 'OnUpdateLevel',
  'ON_GET_USER_TOKEN' = 'OnGetUserToken',
  'ON_GET_USER_INFO' = 'OnGetUserInfo',
  'ON_GET_LEADER_BOARD' = 'OnGetLeaderBoard',
  'ON_GET_LEADER_BOARD_ALL' = 'OnGetLeaderBoardAll',
  'ON_SHARE' = 'OnShare',
  'ON_GET_ITEM_CONFIG' = 'OnGetItemConfig',
}